import { Record as record } from 'immutable';
import { construct, fields } from '../../../../src/helpers/LinkMapper';
import { getDefaults, getResolvers } from '../../../../src/helpers/Records';

const schema = {
    id: [ fields.string ],
    class: [ fields.string ],
    ticketNumber: [ fields.bool ],
    photocardNumber: [ fields.bool ],
    smartcardNumber: [ fields.bool ],
    contactlessNumber: [ fields.bool ],
    oysterNumber: [ fields.bool ],
    ticketUpload: [ fields.bool ],
    statementUpload: [ fields.bool ],
    requiresUpload: [ fields.bool ],
    uploadHint: [ fields.bool ],
    dates: [ fields.bool ],
    price: [ fields.bool ],
    purchaseLocation: [ fields.bool ],
    travelcard: [ fields.bool ],
    weeklyCap: [ fields.bool ],
    fixedDuration: [ fields.duration ]
};

export default class CompensationTicketType extends record(getDefaults(schema)) {
    static fromJSON (json = {}) {
        return construct(CompensationTicketType, json, getResolvers(schema));
    }

    get acceptsUpload () {
        return this.ticketUpload || this.statementUpload;
    }
}
